import React from 'react'
import { Card } from '@/components/Card'
import { RenderBlocks } from '../RenderBlocks'
export type DetailCardBlockProps = {
  title?: string
  variant?: 'default' | 'sidebar' | 'main'
  content?: { id?: string | null; blockType: string; blockName?: string | null }[]
  actions?: { id?: string | null; blockType: string; blockName?: string | null }[]
  blockType: 'detailCard'
}

export const DetailCardBlock: React.FC<DetailCardBlockProps> = ({
  title,
  variant = 'default',
  content,
  actions,
}) => {
  return (
    <Card
      title={title}
      variant={variant}
      actions={actions ? <RenderBlocks blocks={actions} /> : undefined}
    >
      {content ? <RenderBlocks blocks={content} /> : null}
    </Card>
  )
}
